import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
// import Link from 'react-router-dom'; // not needed since using href for navigation

const VAHome = () => {
  return (
    <div className="mt-5 mx-auto" style={{ width: '80%', maxWidth: '800px' }}>
      {/* Using container-lg to cap width at the large breakpoint for VA pages */}
        {/* Placeholder paragraphs */}
        <p>
            Welcome to the VA EHR/CPOE Evaluation Tool
        </p>
        <p>
            VA Healthcare facilities can register for access to the EHR/CPOE tool to review content and start the
            EHR/CPOE assessment process by clicking the registration link below.
        </p>
        <p>
            If you are ready to take the test, follow the prompts for the EHR/CPOE test.
        </p>
        <p>
            For support or assistance, please contact us directly at {' '}
            <a
                href="mailto:Helpdesk_EHRSafetyEvalTool@utah.edu?subject=EHR Safety Eval Tool&body=Hello, I need some help with..."
                target="_blank"
                rel="noopener noreferrer"
            >
                Helpdesk_EHRSafetyEvalTool@utah.edu
            </a>. We are here to help.
        </p>

        {/* Action cards grouped under a common title bar */}
        <Card className="border-0 mb-4">
          {/* Empty title bar spanning both cards */}
          <Card.Header className="bg-primary border-0" style={{ height: '3rem' }} />
          <Card.Body className="p-0">
            <div className="row">
              <div className="col-md-6 mb-3">
                <Card className="h-100 border-0">
                <Card.Body className="d-flex flex-column justify-content-between align-items-start">
                    <Card.Title className="text-left mb-4">Need to register a site?</Card.Title>
                    <Button
                      variant="primary"
                      className="align-self-center"
                      href="https://ehr-evaluation-tool-dev.ctsi.utah.edu/register"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ width: '16ch', whiteSpace: 'normal' }}
                    >
                      Register<br />here
                    </Button>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-md-6 mb-3">
                <Card className="h-100 border-0">
                <Card.Body className="d-flex flex-column justify-content-between align-items-start">
                    <Card.Title className="text-left mb-4">Already registered? Need to access the site or take the test? Enter here.</Card.Title>
                    <Button
                      variant="primary"
                      className="align-self-center"
                      href="/index.html?valogin"
                      target="_self"
                      style={{ width: '16ch', whiteSpace: 'normal' }}
                    >
                      CPOE web<br />portal
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
  );
};

export default VAHome;